import { render, staticRenderFns } from "./CompanySetUp.vue?vue&type=template&id=98f9dd40&scoped=true&"
import script from "./CompanySetUp.vue?vue&type=script&lang=js&"
export * from "./CompanySetUp.vue?vue&type=script&lang=js&"
import style0 from "./CompanySetUp.vue?vue&type=style&index=0&id=98f9dd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f9dd40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabs})
